import { parse, parseISO } from 'date-fns';
import { convertDateFormatToUnicode } from './convert-date-format-to-unicode';
/**
 * Pares a `Date` from a `DateInput` value.
 * This function mimics the behaviour of the `parse` function provided by date-fns v1 (https://date-fns.org/v1.28.0/docs/parse).
 *
 * @hidden
 * @param value The `DateInput` value to be pared.
 * @returns The parsed `Date` value.
 */
export const parseDate = (value, format) => {
    if (value instanceof Date) {
        return value;
    }
    if (typeof value === 'number') {
        return new Date(value);
    }
    if (typeof value !== 'string') {
        throw new Error(`Cannot parse date. Only Date, number and string values can be parsed, ${typeof value} received.`);
    }
    if (format) {
        // Our date formats are old date-fns v1, we need to map the format to a new v2 format
        return parse(value, convertDateFormatToUnicode(format), new Date());
    }
    else {
        return parseISO(value);
    }
};
//# sourceMappingURL=parse-date.js.map